import { render, staticRenderFns } from "./MemberReward.vue?vue&type=template&id=515a7cb0&scoped=true&"
import script from "./MemberReward.vue?vue&type=script&lang=js&"
export * from "./MemberReward.vue?vue&type=script&lang=js&"
import style0 from "./MemberReward.vue?vue&type=style&index=0&id=515a7cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a7cb0",
  null
  
)

export default component.exports